/** @jsxRuntime classic */
/** @jsx jsx */

import { jsx } from '@emotion/react';
import { ReactNode, MouseEvent } from 'react';
import { useAvroTracking } from '../../observability';

type Props = {
  children: ReactNode;
  sectionName: string;
};

export function CTAClickTracking(props: Props) {
  const { emitCTAClickEvent } = useAvroTracking();

  const handleClick = (event: MouseEvent) => {
    const target = event.target as HTMLElement;

    if (target.tagName !== 'A') {
      return;
    }

    emitCTAClickEvent({
      text: target.innerText,
      href: target.getAttribute('href') || '',
      section: props.sectionName,
    });
  };

  return (
    <div
      role="none"
      css={{ display: 'flex', flexDirection: 'column' }}
      onClick={handleClick}
    >
      {props.children}
    </div>
  );
}
